import axios from 'axios';
import { AUTH_COOKIE_NAMES, clearAuthCookiesDocument, clearBrowserSession } from '../authSession';

export function getApiBaseUrl() {
    return process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';
}

export function clearAuthSession() {
    clearAuthCookiesDocument();
    clearBrowserSession();
}

export function handleUnauthorized() {
    clearAuthSession();
    const path = window.location.pathname || '/';
    if (path !== '/' && path !== '/Home') {
        window.location.href = '/';
    }
}

export function getApiClient(cookies) {

    const axiosClient = axios.create({
        headers: {
            'Authorization': `Token ${cookies['myToken']}`,
            'Content-Type': "application/json",
        }
    });

    axiosClient.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response && error.response.status === 401) {
                handleUnauthorized();
            }
            return Promise.reject(error);
        }
    );
    
    return axiosClient;
}